import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import "./ddd.css";

function DDDUI({ imageUrl, onBack, children }) {
  const location = useLocation();
  const isFromMobileApp = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const hasMobileFlag = queryParams.has("fromMobileApp");
    const fromMobileAppParam = queryParams.get("fromMobileApp");
    const normalizedValue = (fromMobileAppParam || "").toLowerCase();

    const isTruthyValue = ["true", "1", "yes"].includes(normalizedValue);
    const isBareFlag = hasMobileFlag && normalizedValue === "";
    const isCurrentRouteFromMobileApp = isTruthyValue || isBareFlag;

    if (isCurrentRouteFromMobileApp) {
      sessionStorage.setItem("fromMobileApp", "true");
      return true;
    }

    if (sessionStorage.getItem("fromMobileApp") === "true") return true;

    try {
      const ud = JSON.parse(sessionStorage.getItem("userData") || "null");
      if (String(ud?.fromMobileApp || "").toLowerCase() === "true") return true;
    } catch {
      /* ignore */
    }

    return false;
  }, [location.search, location.pathname]);

  console.log("isFromMobileApp",isFromMobileApp);

  const homeUrl = (process.env.REACT_APP_BASE_URL || "").trim() || "https://extramileplay.com";

  const handleLogoClick = (e) => {
    e.preventDefault();
    const gs = window.GameStatus;
    if (gs && typeof gs.postMessage === "function") {
      gs.postMessage("navigate_back");
      return;
    }
    if (typeof onBack === "function") onBack();
  };

  return (
    <>
      <header className="upperaction">

      {isFromMobileApp ? (
        <button
          type="button"
          onClick={handleLogoClick}
          className="logo-button"
          aria-label="Go back"
        >
          <img src={imageUrl} className="logo-holder" alt="Company logo" />
        </button>
      ) : (
        <a href={homeUrl} target="_top" rel="noopener noreferrer">
          <img src={imageUrl} className="logo-holder" alt="Company logo" />
        </a>
      )}

        {!isFromMobileApp && (
          <div className="back-holder">
            <button onClick={onBack} className="back-default">Back</button>
          </div>
        )}
       
      </header>
      {children}
    </>
  );
}

export default DDDUI;